<template>
    <div>
        <div class="uk-margin-large-top uk-padding-remove-horizontal uk-text-middle" uk-grid>
            <div class="uk-width-2-3 uk-text-middle">
                <span
                    style="font-size: 1.25rem; line-height: 1.4;"
                >
                    Attachments
                </span>
            </div>
            <div class="uk-width-1-3">
                <button
                    type="button"
                    class="uk-button uk-button-primary uk-align-right"
                    :disabled="!hasFileForUpload"
                    @click="uploadFiles"
                >
                    <div class="uk-inline uk-margin-remove-right">
                        <span class="uk-margin-small-right uk-margin-small-left">
                            {{ isUploading ? 'Uploading files...' : 'Upload files' }}
                        </span>
                    </div>
                </button>
            </div>
        </div>
        <system-message
            :success="uploadSuccess"
            :message="uploadMessage"
            class="uk-text-middle uk-width-1-1@l uk-width-1-1@s"
            @close="clearSystemMessage"
        />
        <div class="uk-margin-top">
            <div v-for="file in attachments" :key="file.id">
                <div uk-grid>
                    <div>
                        <a :href="file.url" target="_blank">
                            {{ file.title }}
                        </a>
                    </div>
                    <div>
                        <button type="button" uk-close @click="showModal(file)"></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="dropzone-container uk-padding uk-text-center uk-text-middle">
            <vue-dropzone
                id="dropzone"
                :key="dropzoneKey"
                ref="attachmentsDropzone"
                :options="dropzoneOptions"
                @vdropzone-success-multiple="uploadFinished"
                @vdropzone-error-multiple="handleDropzoneError"
            />
        </div>
    </div>
</template>

<script>
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { mapGetters } from 'vuex';
import config from '../../helpers/config'

const vue2Dropzone = () => import('vue2-dropzone');
const SystemMessage  = () => import( "@strangeanimals/common-vue-components/src/components/page/SystemMessage");

export default {
    // eslint-disable-next-line vue/no-unused-components
    components: { SystemMessage, vueDropzone: vue2Dropzone },
    props: {
        id: {
            type: Number,
            default: () => {
                return null;
            }
        },
        attachments: {
            type: Array,
            default: () => []
        },
    },
    data: function () {
        return {
            dropzoneKey: 0,
            isUploading: false,
            hasFileForUpload: false,
            uploadMessage: [],
            uploadSuccess: true,
            maxFiles: 10,
        };
    },
    computed: {
        ...mapGetters({
            payments: 'payments',
            loggedInUser: 'user',
            isUserAdmin: 'isUserAdmin',
            defaultRequestParams: 'defaultRequestParams',
            isLoading: 'isLoading',
            apiAccessToken: 'apiAccessToken'
        }),
        dropzoneOptions: function() {
            const theAuthToken = this.apiAccessToken;
            const self = this;
            return {
                url: config.apiUrl + '/payment/app/uploadPaymentFiles',
                method: 'POST',
                thumbnailWidth: 120,
                headers: {
                    ...(theAuthToken ? { Authorization: 'Bearer ' + theAuthToken } : {}),
                },
                autoProcessQueue: false,
                addRemoveLinks: true,
                uploadMultiple: true,
                parallelUploads: this.maxFiles,
                params: {
                    id: this.id
                },
                init: function() {
                    this.on('addedfiles', function() {
                        self.hasFileForUpload = true;
                    });

                    this.on('removedfile', function (file) {
                        self.hasFileForUpload = this.files.length > 0;
                    });
                },
            };
        },
    },
    methods: {
        uploadFiles() {
            this.isUploading = true;
            this.hasFileForUpload = false;
            this.$refs.attachmentsDropzone.processQueue();
        },
        uploadFinished(files, response) {
            this.isUploading = false;
            this.hasFileForUpload = false;

            if (response.success) {
                this.$refs.attachmentsDropzone.removeAllFiles();
                this.$emit('reload', this.id);

                let message = [];
                const data = response.data;

                if (data.success)
                {
                    let successMsg = 'Successfully uploaded '
                    successMsg += (data.success === 1) ? '1 file' : data.success + ' files';
                    message.push(successMsg);
                }

                if (data.failures)
                {
                    let failureMsg = 'Failed to upload '
                    failureMsg += (data.failures === 1) ? '1 file' : data.failures + ' files';
                    message.push(failureMsg);
                }

                this.setUploadMessage(message, true);
            }
            else {
                this.setUploadMessage(['Upload failed.'], false);
            }
        },
        handleDropzoneError: function (files, response) {
            this.isUploading = false;
            this.setUploadMessage(['Upload failed.'], false);
            this.$refs.attachmentsDropzone.removeAllFiles();
            this.hasFileForUpload = false;
        },
        setUploadMessage(message, isSuccess) {
            this.uploadMessage = message;
            this.uploadSuccess = isSuccess;
        },
        showModal(file) {
            this.$emit('showDeleteAttachmentModal', file);
        },
        clearSystemMessage() {
            this.uploadMessage = [];
            this.uploadSuccess = true;
        },
    },
}
</script>